<template >
  <!-- 0.1像素线条 -->
  <div class="page-header">
    <div v-text="title"></div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
}
</script>
<style lang='stylus' scoped>
.page-header {
  div {
    padding-bottom: 20px;
    color: #70af00;
    font-size: 40px;
    font-weight: bold;
  }
}
</style>
